export default __webpack_public_path__ + "static/media/westand.38f340ac.jpg";